import { EVENT_KEY_BACKSPACE, EVENT_KEY_DELETE } from '../../../../const';
import { CLASS_HTML_EDITOR } from '../components/HtmlEditor/constants';
import { getParentsClasses } from '../../helpers/getParentsClasses';

export const isKeyDelete = (
    e: KeyboardEvent
): boolean => {
    if (e.altKey || e.ctrlKey || e.shiftKey) return false;

    const targetElement = e.target as HTMLElement;
    const targetTagName = targetElement && targetElement.tagName
        ? targetElement.tagName.toLowerCase() : '';
    const parentClasses = getParentsClasses(targetElement, [
        CLASS_HTML_EDITOR
    ]);
    if (
        'textarea' === targetTagName ||
        'input' === targetTagName ||
        parentClasses.includes(CLASS_HTML_EDITOR)
    ) return false;

    const isMac = navigator.platform.indexOf('Mac') > -1;

    return isMac ? EVENT_KEY_BACKSPACE === e.key : EVENT_KEY_DELETE === e.key;
}
